(() => {
  'use strict';
  const page = document.querySelector('[data-catalogue]');
  if (!page) return;
  const grid = page.querySelector('.collection-grid');
  const more = page.querySelector('[data-collection-more]');
  const button = more.querySelector('[data-load-more]');
  const status = more.querySelector('[data-catalogue-status]');
  const note = more.querySelector('[data-scroll-note]');
  const retry = more.querySelector('[data-retry-filter]');
  const clear = more.querySelector('[data-clear-cuts]');
  const regularControls = page.querySelector('[data-regular-controls]');
  const sizeHost = page.querySelector('[data-outlet-sizes]');
  const form = page.querySelector('#CollectionFilters');
  const collectionCount = page.querySelector('[data-collection-count]');
  const initialCount = collectionCount?.textContent;
  const initialNodes = [...grid.children];
  const initialNext = more.dataset.next;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fields = {};
  for (const key of ['atelier_fit', 'atelier_regular', 'atelier_size']) {
    const field = document.createElement('input');
    field.type = 'hidden'; field.name = key; form.append(field); fields[key] = field;
  }
  const urlKey = url => {
    const copy = new URL(url); copy.searchParams.delete('preview_theme_id');
    return copy.pathname + copy.search;
  };
  const remembered = history.state?.atelierCatalogue;
  const restore = remembered?.key === urlKey(location.href) ? remembered : null;
  let selection = {fit: '', regular: '', size: ''};
  let requestedSelection = {...selection};
  let next = initialNext;
  let automatic = false;
  let busy = false;
  let generation = 0;
  let pagesLoaded = 1;
  let catalogPromise;
  let matches = null;
  let shown = 0;
  let failedSelection = null;
  let restoring = !!restore;
  const normalise = value => String(value).trim().toUpperCase().replace(/^2XL$/, 'XXL').replace(/^3XL$/, 'XXXL');
  const hasSelection = value => !!(value.fit || value.size);
  const cards = () => [...grid.querySelectorAll('[data-product-id]')];
  const hasMore = () => matches ? shown < matches.length : !!next;
  function save() {
    if (restoring) return;
    try {
      history.replaceState({...history.state, atelierCatalogue: {
        key: urlKey(location.href), pages: pagesLoaded, shown, automatic, scroll: window.scrollY
      }}, '', location.href);
    } catch { /* Browsers can restrict history writes without affecting browsing. */ }
  }
  function controls(value) {
    page.querySelectorAll('[data-fit]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.fit === value.fit)));
    page.querySelectorAll('[data-regular]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.regular === value.regular)));
    sizeHost?.querySelectorAll('[data-size]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.size === value.size)));
    if (regularControls) regularControls.hidden = value.fit !== 'regular';
    fields.atelier_fit.value = value.fit; fields.atelier_regular.value = value.regular; fields.atelier_size.value = value.size;
  }
  function writeUrl() {
    const url = new URL(location.href);
    for (const [key, field] of Object.entries(fields)) {
      if (field.value) url.searchParams.set(key, field.value); else url.searchParams.delete(key);
    }
    if (hasSelection(selection)) url.searchParams.delete('page');
    history.replaceState({...history.state}, '', url);
    page.querySelectorAll('.active-filters a').forEach(link => {
      const target = new URL(link.href);
      for (const [key, field] of Object.entries(fields)) {
        if (field.value) target.searchParams.set(key, field.value); else target.searchParams.delete(key);
      }
      link.href = target.href;
    });
    save();
  }
  function renderProgress() {
    if (collectionCount) collectionCount.textContent = matches ? `${matches.length} ${collectionCount.dataset.productsLabel}` : initialCount;
    button.hidden = !hasMore(); button.disabled = busy;
    note.hidden = !hasMore();
    note.textContent = automatic ? more.dataset.auto : more.dataset.startNote;
    clear.hidden = !hasSelection(selection);
    retry.hidden = !failedSelection;
    if (!busy && !failedSelection) {
      status.textContent = matches
        ? (matches.length ? more.dataset.count.replace('[count]', String(matches.length)) : more.dataset.empty)
        : (!next ? more.dataset.end : '');
    }
  }
  function busyState(value) {
    busy = value; button.disabled = value;
    if (value) { status.textContent = more.dataset.loading; grid.setAttribute('aria-busy', 'true'); }
    else grid.removeAttribute('aria-busy');
  }
  async function readSection(url, selector) {
    const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(20000)});
    if (!response.ok) throw new Error('catalogue');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const root = doc.querySelector(selector);
    if (!root || root.textContent.includes('Liquid error')) throw new Error('catalogue');
    return root;
  }
  function sourceUrl(target, section) {
    const url = new URL(target, location.origin);
    if (url.origin !== location.origin) throw new Error('origin');
    url.searchParams.set('section_id', section);
    for (const key of Object.keys(fields)) url.searchParams.delete(key);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }
  function append(nodes, focus = false) {
    const seen = new Set(cards().map(el => el.dataset.productId));
    const added = nodes.filter(node => {
      const card = node.matches('[data-product-id]') ? node : node.querySelector('[data-product-id]');
      if (!card || seen.has(card.dataset.productId)) return false;
      seen.add(card.dataset.productId); return true;
    });
    grid.append(...added);
    if (!reduced.matches && !restoring) added.slice(0, 4).forEach((node, i) => {
      node.animate?.([{opacity: .4, transform: 'translateY(12px)'}, {opacity: 1, transform: 'translateY(0)'}],
        {duration: 280, delay: i * 35, easing: 'cubic-bezier(.22,1,.36,1)'});
    });
    if (focus) added[0]?.querySelector('.card-image-link')?.focus({preventScroll: true});
  }
  async function loadMore(focus = false) {
    if (busy || !hasMore()) return false;
    const current = ++generation;
    busyState(true);
    try {
      if (matches) {
        const batch = matches.slice(shown, shown + 24); shown += batch.length; append(batch, focus);
      } else {
        let nodes = [];
        let following = next;
        let fetched = 0;
        do {
          const root = await readSection(sourceUrl(following, page.dataset.section), '[data-catalogue]');
          if (current !== generation) return false;
          const sourceGrid = root.querySelector('.collection-grid');
          const sourceMore = root.querySelector('[data-collection-more]');
          if (!sourceGrid || !sourceMore) throw new Error('catalogue');
          nodes = [...sourceGrid.children].filter(node => node.matches('[data-product-id]'));
          const previous = following; following = sourceMore.dataset.next; fetched++;
          if (following && following === previous) throw new Error('pagination');
        } while (!nodes.length && following);
        append(nodes, focus); next = following; pagesLoaded += fetched;
      }
      busyState(false); renderProgress(); save(); return true;
    } catch {
      if (current !== generation) return false;
      busyState(false); automatic = false; renderProgress(); status.textContent = more.dataset.error;
      return false;
    }
  }
  async function loadCatalog() {
    const url = sourceUrl(location.href, 'atelier-outlet-stock'); url.searchParams.set('page', '1');
    const root = await readSection(url, '[data-outlet-stock]');
    const count = Number(root.dataset.pages);
    if (!Number.isInteger(count) || count < 0) throw new Error('catalogue');
    const nodes = [...root.querySelectorAll('[data-outlet-item]')];
    for (let number = 2; number <= count; number++) {
      url.searchParams.set('page', String(number));
      const part = await readSection(url, '[data-outlet-stock]'); nodes.push(...part.querySelectorAll('[data-outlet-item]'));
    }
    return nodes.map(node => ({node, card:node.querySelector('[data-product-id]'), variants:JSON.parse(node.querySelector('[data-outlet-variants]').textContent)}));
  }
  function filterItems(items, value) {
    return items.flatMap(item => {
      if (!item.card || (value.fit && item.card.dataset.productFit !== value.fit) ||
        (value.regular && item.card.dataset.regularCut !== value.regular)) return [];
      const variant = value.size ? item.variants.find(v => v.available && normalise(v.size) === value.size) : null;
      if (value.size && !variant) return [];
      const node = item.node.cloneNode(true);
      if (variant) {
        node.querySelectorAll('a[href]').forEach(link => {
          const url = new URL(link.getAttribute('href'), location.origin); url.searchParams.set('variant', variant.id);
          link.href = url.href; if (link.hasAttribute('data-quick')) link.dataset.quick = url.href;
        });
        const price = node.querySelector('.card-price');
        if (price) {
          price.replaceChildren(document.createTextNode(variant.price));
          if (variant.compare) { const old = document.createElement('s'); old.textContent = variant.compare; price.append(' ', old); }
        }
        const badge = node.querySelector('.sale-badge'); if (badge) badge.hidden = true;
      }
      return [node];
    });
  }
  async function choose(value, write = true, restoreCount = 24) {
    const current = ++generation;
    requestedSelection = {...value};
    automatic = false; failedSelection = null; controls(value); busyState(true); retry.hidden = true;
    try {
      let result = null;
      if (hasSelection(value)) {
        catalogPromise ||= loadCatalog().catch(error => {catalogPromise = null; throw error;});
        const items = await catalogPromise;
        if (current !== generation) return;
        result = filterItems(items, value);
      }
      if (current !== generation) return;
      selection = {...value}; matches = result; pagesLoaded = 1;
      if (matches) {
        shown = Math.min(matches.length, Math.max(24, restoreCount)); next = '';
        grid.replaceChildren(...matches.slice(0, shown));
      } else { shown = 0; next = initialNext; grid.replaceChildren(...initialNodes); }
      busyState(false); renderProgress();
      if (write) writeUrl();
    } catch {
      if (current !== generation) return;
      failedSelection = {...value}; requestedSelection = {...selection}; controls(selection); busyState(false); renderProgress(); status.textContent = more.dataset.error;
    }
  }
  button.addEventListener('click', () => { automatic = true; loadMore(true); });
  retry.addEventListener('click', () => { if (failedSelection) choose(failedSelection); });
  clear.addEventListener('click', () => { choose({fit:'', regular:'', size:''}); page.querySelector('[data-fit=""]')?.focus({preventScroll:true}); });
  page.querySelectorAll('[data-fit]').forEach(el => el.addEventListener('click', () => choose({...requestedSelection, fit:el.dataset.fit, regular:''})));
  page.querySelectorAll('[data-regular]').forEach(el => el.addEventListener('click', () => choose({...requestedSelection, fit:'regular', regular:el.dataset.regular})));
  sizeHost?.querySelectorAll('[data-size]').forEach(el => el.addEventListener('click', () => choose({...requestedSelection, size:el.dataset.size})));
  const sentinel = more.querySelector('[data-catalogue-sentinel]');
  function continueAutomatically() {
    if (automatic && !busy && !restoring && !failedSelection && hasMore() &&
      sentinel.getBoundingClientRect().top <= window.innerHeight + 180) loadMore();
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) continueAutomatically();
  }, {rootMargin:'0px 0px 180px 0px'}) : null;
  observer?.observe(sentinel);
  let scrollQueued = false;
  window.addEventListener('scroll', () => {
    if (!automatic || busy || scrollQueued) return;
    scrollQueued = true;
    requestAnimationFrame(() => { scrollQueued = false; continueAutomatically(); });
  }, {passive:true});
  page.classList.add('catalogue-enhanced');
  more.dataset.startNote = note.textContent;
  window.addEventListener('pagehide', save);
  const params = new URL(location.href).searchParams;
  const initial = {
    fit:['regular','oversized'].includes(params.get('atelier_fit')) ? params.get('atelier_fit') : '',
    regular:['classic','relaxed'].includes(params.get('atelier_regular')) ? params.get('atelier_regular') : '',
    size:sizeHost ? normalise(params.get('atelier_size') || '') : ''
  };
  if (initial.fit !== 'regular') initial.regular = '';
  if (initial.size && ![...sizeHost.querySelectorAll('[data-size]')].some(el => el.dataset.size === initial.size)) initial.size = '';
  async function start() {
    if (hasSelection(initial)) await choose(initial, false, restore?.shown || 24);
    else {
      controls(initial); renderProgress();
      for (let i = 1; i < Math.min(restore?.pages || 1, 50) && next; i++) if (!await loadMore()) break;
    }
    if (restore) { automatic = restore.automatic; window.scrollTo({top:restore.scroll || 0, behavior:'instant'}); }
    restoring = false; renderProgress(); save();
  }
  start();
})();
